export class Stats {
    constructor() {
        this.startStats();
    }

    startStats() {
        this.script = document.createElement('script');
        this.script.type = 'text/javascript';
        this.script.async = true;
        this.script.src = 'https://www.googletagmanager.com/gtag/js?id=G-PD9HH0G5CS';    
        document.head.appendChild(this.script);

        this.script2 = document.createElement('script');
        this.script2.type = 'text/javascript';
        this.script2.innerHTML = `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-PD9HH0G5CS', { client_storage: 'none', 'anonymize_ip': true });`
        // gtag('config', 'G-PD9HH0G5CS', { cookie_expires: 34164000, cookie_update: false, 'anonymize_ip': true }); 

        document.head.appendChild(this.script2);

    }
}